export const environment = {
	production: true,
	environmentName: 'production',
	baseUrl: 'https://app.everyqa.io/api',
};
